import React from "react";
import { useTranslation } from "react-i18next";
import { formatDateTime } from "../../utils/format";
import Rows from "../../components/Rows";
import CloseIcon from "../../icons/x.svg";

const BLPopup = ({ data, product, onChoisir, onClose }) => {
  const { t } = useTranslation();

  const rows = data.map(item => {
    const matchingProduct = item.carts?.[0]?.details?.find(
      detail => detail.product?.id === product
    );
    return { ...item, matchingProduct };
  });

  const handleChoisirClick = (row) => {
    if (onChoisir) {
      onChoisir(row.matchingProduct, row.deliveryNoteNumber, row.createdAt);
    }
  };

  const columns = [
    { label: t("columns.createdAt"), key: "createdAt", render: (_, row) => formatDateTime(row.createdAt) },
    { label: t("columns.deliveryNoteNumber"), key: "deliveryNoteNumber" },
    {
      label: t("columns.quantity"),
      key: "quantity",
      render: (_, row) => row.matchingProduct?.quantity 
    },
    {
      label: t("rows.priceuBrut"),
      key: "unitprice",
      render: (_, row) => row.matchingProduct?.unitPrice 
    },
    {
      label: t("columns.discount"),
      key: "discount",
      render: (_, row) => row.matchingProduct?.discount
    },
    {
      label: t("rows.priceuHT"),
      key: "priceHT",
      render: (_, row) => (row.matchingProduct?.unitPrice)*(1-row.matchingProduct?.discount/100) 
    },
    {
      label: t("rows.priceuTTC"),
      key: "priceTTC",
      render: (_, row) => (row.matchingProduct?.unitPrice)*(1-row.matchingProduct?.discount/100)*(1+20/100)
    },
    {
      label: t("rows.returned"),
      key: "returned",
      render: (_, row) => row.matchingProduct?.returned 
    },
    {
      label: ' ',
      key: 'actions',
      render: (_, row) => (
        <button
          onClick={() => handleChoisirClick(row)}
          className="flex px-4 py-2 items-center justify-center text-white text-[14px] font-bold bg-[#043F88] rounded-[12px] shadow-[0px_6px_26px_rgba(98,107,125,0.07)]"

        >
          {t("actions.choose")}
        </button>
      ),
    },
  ];

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-[1050]">
      <div className="relative bg-[#F9FAFC] h-[450px] rounded-lg p-8 shadow-lg flex flex-col max-w-[90%] w-3/4 min-w-[400px]">
        {/* Close Button */}
        <button
          className="absolute top-4 right-4 w-8 h-8 bg-[#F2F3F3] flex items-center justify-center rounded-full "
          onClick={onClose}
        >
          <img src={CloseIcon} alt="Close" />
          </button>

        {/* Title */}
        <div className="mb-4">
          <h1 className="text-[24px] font-semibold text-black">
            {t("titles.chooseBL")}
          </h1>
        </div>

        {/* Scrollable BL List */}
        <div className="flex-1 overflow-y-auto mb-4">
          <Rows columns={columns} data={rows} expandable={false} wrapLayout={true} />
        </div>
      </div>
    </div>
  );
};

export default BLPopup;
